import styled from 'styled-components';
import { ITheme } from '../../styles/theme';

export const TooltipCont = styled.div`
  position: relative;
  display: flex;
`;

interface ITooltipBody {
  theme: ITheme;
  active?: boolean;
  position?: 'top' | 'bottom';
  positionX?: string;
  positionY?: string;
  arrowPositionX?: string;
  background?: string;
  width?: string;
}
export const TooltipBody = styled.div<ITooltipBody>`
  text-transform: none;
  position: absolute;
  z-index: 100;
  background: ${({ background }: ITooltipBody) => background || 'rgba(0, 0, 0, 0.7)'};
  border-radius: 4px;

  &:after {
    content: '';
    position: absolute;
    left: 10px;
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: 4px solid rgba(0, 0, 0, 0.7);
    ${({ arrowPositionX, position }: ITooltipBody) => `
      left: ${arrowPositionX || '10px'};
      ${position === 'bottom' ? 'top: -4px' : 'bottom: -4px'};
      ${position === 'top' ? 'transform: rotate(180deg)' : ''}
    `}
  }
  ${({ theme, width, position, positionX, positionY }: ITooltipBody) => `
          color: ${theme.colors.neutral.primary[0]};
          padding:  ${theme.layout.spacing.mikro} ${theme.layout.spacing.mili};
          ${position === 'bottom' ? 'bottom: "auto"' : `bottom: ${positionY || '30px'}`};
          ${position === 'bottom' ? `top: ${positionY || '30px'}` : `bottom: ${positionY}`};
          left: ${positionX || '-5px'};
          width: ${width || '320px'};
  `}
`;
